enum CommandTypes {
    bgp         = "bgp",
    ping        = "ping",
    traceroute  = "traceroute",
}

export default CommandTypes;